import { AsyncPipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ListInput } from '@app/shared/form/models';
import { TranslateModule } from '@ngx-translate/core';
import { BaseInputComponent } from './../base-input/base-input.component';

@Component({
	selector: 'app-list-input',
	template: `
		@if ((control.options | async)?.length) {
			@for (option of control.options | async; track option) {
				<div
					[attr.id]="controlId"
					class="text-semi-dark mt-3"
					[class]="control.class.join(' ')"
				>
					{{ option }}
				</div>
			}
		} @else {
			<div class="text-semi-dark mt-3" [class]="control.class.join(' ')">
				{{ control.placeholder | translate }}
			</div>
		}
	`,
	standalone: true,
	imports: [AsyncPipe, TranslateModule]
})
export class ListInputComponent extends BaseInputComponent {
	@Input({ required: true }) override control: ListInput;
}
